import { FC, LabelHTMLAttributes, ReactNode } from 'react'
import styled from 'styled-components'

import { inputId } from 'aem-libs-tests/src/constants/inputId'
import { createTestId } from 'aem-libs-tests/src/utility/createTestId'

import { Tip, TipProps } from '../../common/tip'

export const LabelStyled = styled.label`
  padding: 0 0 10px 3px;
  display: flex;
  align-items: center;
  text-align: left;
  font-weight: 600;
  font-size: 16px;
  position: relative;
`

export interface LabelProps extends LabelHTMLAttributes<unknown> {
  label: string | ReactNode
  tip?: TipProps
  testId?: string
}

export const Label: FC<LabelProps> = ({ label, tip, testId, ...labelProps }) => {
  return (
    <>
      {label && (
        <LabelStyled {...labelProps} data-testid={createTestId(testId ?? 'label', inputId.label)}>
          {label}
          {tip?.text && (
            <Tip {...tip} fieldId={labelProps.htmlFor} testId={createTestId(testId ?? 'tip', inputId.tip)} />
          )}
        </LabelStyled>
      )}
    </>
  )
}
